// @ts-nocheck
import _ from "lodash";
import {
  ADD_CONTRACTOR_LINK_FAILURE,
  ADD_CONTRACTOR_LINK_REQUEST,
  ADD_CONTRACTOR_LINK_SUCCESS,
  CLOSE_MANAGE_APPROVALS_MODAL,
  CLOSE_VIEW_DOCUMENT_MODAL,
  DELETE_CONTRACTOR_LINK_FAILURE,
  DELETE_CONTRACTOR_LINK_REQUEST,
  DELETE_CONTRACTOR_LINK_SUCCESS,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST,
  FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS,
  FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE,
  FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST,
  FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST,
  FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST,
  GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS,
  GET_CONTRACTOR_LINK_FAILURE,
  GET_CONTRACTOR_LINK_REQUEST,
  GET_CONTRACTOR_LINK_SUCCESS,
  OPEN_MANAGE_APPROVALS_MODAL,
  OPEN_VIEW_DOCUMENT_MODAL,
  UPDATE_MANAGE_APPROVAL_DATA,
} from "../../constants/config/contractorLink";

const initialState = {
  links: [],
  isLoading: true,
  deleteLoading: {
    deleteId: null,
    loading: false,
  },

  documents: {
    modalStatus: false,
    contractorDetails: null,
    loading: true,
    contractorId: null,
  },

  contractorPDFUrls: {},
  contractorPdfLoading: false,
  contractorPdfStatus: "idle",

  // NOTE: manage approvals
  manageApprovals: {
    open: false,
    contractorId: null,
    isLoading: true,
    contractorDetails: null,
  },
};

const contractorLinkReducer = (state = initialState, action) => {
  switch (action?.type) {
    case GET_CONTRACTOR_LINK_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case GET_CONTRACTOR_LINK_SUCCESS:
      return {
        ...state,
        links: action?.payload,
        isLoading: false,
      };

    case GET_CONTRACTOR_LINK_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // add contractor link
    case ADD_CONTRACTOR_LINK_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case ADD_CONTRACTOR_LINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case ADD_CONTRACTOR_LINK_FAILURE:
      return {
        ...state,
        isLoading: false,
      };

    // delete contractor link
    case DELETE_CONTRACTOR_LINK_REQUEST:
      return {
        ...state,
        deleteLoading: {
          deleteId: action?.payload,
          loading: true,
        },
      };

    case DELETE_CONTRACTOR_LINK_FAILURE:
      return {
        ...state,
        deleteLoading: {
          deleteId: null,
          loading: false,
        },
      };

    case DELETE_CONTRACTOR_LINK_SUCCESS: {
      const deletedId = action?.payload?.data?._id;
      return {
        ...state,
        links: state?.links?.filter((l) => l?._id != deletedId),
        deleteLoading: {
          deleteId: null,
          loading: false,
        },
      };
    }

    // open/close view document modal
    case OPEN_VIEW_DOCUMENT_MODAL:
      return {
        ...state,
        documents: {
          ...state?.documents,
          modalStatus: true,
          contractorId: action?.payload,
        },
      };

    case CLOSE_VIEW_DOCUMENT_MODAL:
      return {
        ...state,
        documents: {
          ...state?.documents,
          modalStatus: false,
          contractorId: null,
          contractorDetails: null,
        },
      };

    // fetch all contractor documents
    case FETCH_ALL_CONTRACTOR_DOCUMENTS_REQUEST:
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: true,
        },
      };

    case FETCH_ALL_CONTRACTOR_DOCUMENTS_SUCCESS:
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: false,
          allDocuments: action?.payload,
        },
      };

    case FETCH_ALL_CONTRACTOR_DOCUMENTS_FAILURE:
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: false,
        },
      };

    // fetch contractor document url
    case FETCH_CONTRACTOR_DOCUMENT_URL_REQUEST:
      return {
        ...state,
        contractorPdfLoading: true,
        contractorPdfStatus: "loading",
      };

    case FETCH_CONTRACTOR_DOCUMENT_URL_SUCCESS: {
      const result = _.groupBy(action?.payload?.result, "contractorType");

      return {
        ...state,
        contractorPdfLoading: false,
        contractorPDFUrls: result,
        contractorPdfStatus: "success",
      };
    }

    case FETCH_CONTRACTOR_DOCUMENT_URL_FAILURE:
      return {
        ...state,
        contractorPdfLoading: false,
        contractorPdfStatus: "error",
      };

    // fetch contractor documents by id
    case FETCH_CONTRACTOR_DOCUMENTS_BY_ID_REQUEST:
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: true,
        },
      };

    case FETCH_CONTRACTOR_DOCUMENTS_BY_ID_FAILURE:
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: false,
        },
      };

    case FETCH_CONTRACTOR_DOCUMENTS_BY_ID_SUCCESS: {
      return {
        ...state,
        documents: {
          ...state?.documents,
          loading: false,
          contractorDetails: action?.payload,
        },
      };
    }

    // NOTE: manage approvals modal actions
    case OPEN_MANAGE_APPROVALS_MODAL: {
      return {
        ...state,
        manageApprovals: {
          ...state?.manageApprovals,
          open: true,
          contractorId: action?.payload?.contractorId,
        },
      };
    }

    case CLOSE_MANAGE_APPROVALS_MODAL: {
      return {
        ...state,
        manageApprovals: initialState?.manageApprovals,
      };
    }

    case GET_CONTRACTOR_FOR_MANAGE_APPROVALS_REQUEST: {
      return {
        ...state,
        manageApprovals: {
          ...state?.manageApprovals,
          isLoading: true,
        },
      };
    }

    case GET_CONTRACTOR_FOR_MANAGE_APPROVALS_SUCCESS: {
      return {
        ...state,
        manageApprovals: {
          ...state?.manageApprovals,
          isLoading: false,
          contractorDetails: action?.payload,
        },
      };
    }

    case GET_CONTRACTOR_FOR_MANAGE_APPROVALS_FAILURE: {
      return {
        ...state,
        manageApprovals: {
          ...state?.manageApprovals,
          isLoading: false,
        },
      };
    }

    case UPDATE_MANAGE_APPROVAL_DATA: {
      return {
        ...state,
        manageApprovals: {
          ...state?.manageApprovals,
          contractorDetails: {
            ...state?.manageApprovals?.contractorDetails,
            [action?.payload?.key]: action?.payload?.value,
          },
        },
      };
    }

    default:
      return state;
  }
};

export default contractorLinkReducer;
export { initialState };